<template>
	<div class="prayerContainer">
		<div v-for="(prayer) in prayers" :key="prayer.prayerId" class="prayerDiv">
			<span v-if="prayer.visDate">{{prayer.legibleDate}}<br/></span>
			<span v-if="prayer.isPrivate">Private: </span>{{prayer.prayer}} <transition name="fade" mode="out-in">
				<a v-if="!prayer.deleteInit" class="deleteLink" href="javascript:;" @click="prayer.deleteInit = true">Delete this prayer.</a>
				<a v-else class="deleteLink" href="javascript:;" @click="deletePrayer(prayer)">Are you sure? (click again)</a>
			</transition>
		</div>
	</div>
</template>

<script>

import prayerService from "@/services/prayerService.js"


export default{
	name: "AdminChart",
	props: ["client"],
	data: () =>{return {
		prayers: [],
	}},
	beforeMount(){
		prayerService.getAdminPrayers(this.client, this.$store.state.userToken).then(prayers => {
			this.prayers = prayerService.preparePrayers(prayers);
		});
	},
	methods: {
		async deletePrayer(prayer){
			
			let result = await prayerService.deletePrayer(this.client, prayer.prayerId, this.$store.state.userToken);
			
			//We can just remove the one prayer from the ui
			if(result){
				let prayerIndex = this.prayers.indexOf(prayer);
				if(prayerIndex > -1){
					this.prayers.splice(prayerIndex, 1);
					prayerService.preparePrayers(this.prayers);
				}
			}
		}
	}
}
</script>


<style scoped>

@font-face { font-family: "Roboto Condensed"; src: url("https://fonts.gstatic.com/s/robotocondensed/v19/ieVl2ZhZI2eCN5jzbjEETS9weq8-19K7DQ.woff2") format("woff2"); font-style: normal; font-weight: 400; unicode-range: U+0-FF, U+131, U+152-153, U+2BB-2BC, U+2C6, U+2DA, U+2DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }

.prayerContainer{
	font-weight: 700;
	font-style: normal;
	font-family: 'Roboto Condensed', sans-serif;
	font-size: 18px;
	line-height: 1.5;
	letter-spacing: 0px;
	margin-left: auto;
	margin-right: auto;
	text-align: left;

	max-width: 90vw;
	width: 800px;

}

.deleteLink{
	font-weight: 400;
	font-style: normal;
	font-family: 'Roboto Condensed', sans-serif;
	color: #8d0d26;
	font-size: 14px;
	line-height: 1.6;
	letter-spacing: 0px;
	white-space: nowrap;

}

.prayerDiv{
	margin-bottom: 20px;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

</style>